"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const stockpile_types_1 = require("./stockpile.types");
const stockpile_1 = require("services/master-data/stockpile");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, stockpile_1._getMasterStockpile)(dataStates);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: response.isError
        };
        dispatch({ type: stockpile_types_1.stockpileTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { target_queue_time_display: item.target_queue_time ? item.target_queue_time + ' Minutes' : '', target_lead_time_display: item.target_lead_time ? item.target_lead_time + ' Minutes' : '', created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: stockpile_types_1.stockpileTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield (0, stockpile_1._getMasterStockpile)(dataStates);
    const payload = {
        dataGrid: res.isError ? [] : res.data.map(item => {
            return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
        }),
        dataStates
    };
    dispatch({ type: stockpile_types_1.stockpileTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: stockpile_types_1.stockpileTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode } = payload;
    const response = payload.mutationMode === 'add' ?
        yield (0, stockpile_1._createStockpile)({
            stockpile: payload.dataItem.stockpile,
            description: payload.dataItem.description,
            is_active: payload.dataItem.is_active.value,
            target_lead_time: payload.dataItem.target_lead_time,
            target_queue_time: payload.dataItem.target_queue_time
        }) :
        yield (0, stockpile_1._editStockpile)({
            id: payload.dataItem.id,
            stockpile: payload.dataItem.stockpile,
            description: payload.dataItem.description,
            is_active: payload.dataItem.is_active.value,
            target_lead_time: payload.dataItem.target_lead_time,
            target_queue_time: payload.dataItem.target_queue_time
        });
    const dataItem = Object.assign(Object.assign({}, payload.dataItem), { id: response.data.id });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({ type: stockpile_types_1.stockpileTypes.ON_SAVE_DATAITEM, payload: Object.assign(Object.assign({}, payload), { dataItem, mutationMode, isSuccess }) });
    }
    else {
        dispatch({ type: stockpile_types_1.stockpileTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }) });
    }
});
const onDelete = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, stockpile_1._deleteStockpile)({ id: payload.dataItem.id });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({ type: stockpile_types_1.stockpileTypes.ON_DELETE, payload: Object.assign(Object.assign({}, payload), { isSuccess }) });
    }
    else {
        dispatch({ type: stockpile_types_1.stockpileTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }) });
    }
});
const onFilterChange = payload => dispatch => {
    dispatch({ type: stockpile_types_1.stockpileTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: stockpile_types_1.stockpileTypes.ON_SORT_CHANGE, payload });
};
const toggleError = payload => dispatch => {
    dispatch({ type: stockpile_types_1.stockpileTypes.SET_ERROR, payload });
};
const onLoading = () => dispatch => {
    dispatch({ type: stockpile_types_1.stockpileTypes.SET_LOADING, payload: true });
};
exports.default = {
    getDataGrid,
    onDataStateChange,
    onClickMutation,
    onSaveDataItem,
    onDelete,
    onFilterChange,
    onSortChange,
    toggleError,
    onLoading
};
